var swiper = new Swiper(".related-product", {
      slidesPerView: 1, 
      spaceBetween: 24,
      centerInsufficientSlides: true,
      navigation: {
        nextEl: ".arrow-style-next",
        prevEl: ".arrow-style-prev",
      },
      
      breakpoints: {
        1025: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 14,
        },
        450: {
          slidesPerView: 2,
          spaceBetween: 14,
        },
        375: {
          slidesPerView: 1,
        }
      },
      on: {
        init: function () {
          toggleNavigationArrows(this);
        },
        resize: function () {
          toggleNavigationArrows(this);
        },
      }
    });


    function toggleNavigationArrows(swiper) {
      const totalSlides = swiper.slides.length;
      const currentSlidesPerView = getSlidesPerView(swiper);  // Get the current number of visible slides
    
      if (totalSlides <= currentSlidesPerView) {
        // Hide arrows if all slides fit or there is only one slide
        swiper.navigation.nextEl.style.display = 'none';
        swiper.navigation.prevEl.style.display = 'none';
      } else {
        // Show arrows if not all slides fit
        swiper.navigation.nextEl.style.display = 'block';
        swiper.navigation.prevEl.style.display = 'block';
      }
    }
    
    // Function to get the current slides per view based on Swiper's configuration
    function getSlidesPerView(swiper) {
      let slidesPerView = swiper.params.slidesPerView;
      if (typeof slidesPerView === 'string' || slidesPerView === 'auto') {
        // If slidesPerView is 'auto', calculate the number of visible slides
        slidesPerView = Math.floor(swiper.width / swiper.slides[0].clientWidth);
      }
      return slidesPerView;
    }

var swiper = new Swiper(".custom-articles", {
  slidesPerView: 1,
  grid: {
    rows: 2,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});
